import * as Types from "../Constants/AllConstants";

export const StockOverviewReducer = (
  state = { stockOverview: [], pageInfo: {}, loading: false },
  action
) => {
  switch (action.type) {
    case Types.GET_STOCK_OVERVIEW_REQUEST:
      return { ...state, loading: true };
    case Types.GET_STOCK_OVERVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        stockOverview: action.payload.content || [],
        pageInfo: {
          page: action.payload.number,
          size: action.payload.size,
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
        },
      };
    case Types.GET_STOCK_OVERVIEW_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const StockSummaryReducer = (state = { summary: {}, loading: false }, action) => {
  switch (action.type) {
    case Types.GET_STOCK_SUMMARY_REQUEST:
      return { ...state, loading: true };
    case Types.GET_STOCK_SUMMARY_SUCCESS:
      return { ...state, loading: false, summary: action.payload };
    case Types.GET_STOCK_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UpdateStockReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.UPDATE_PRODUCT_STOCK_REQUEST:
      return { loading: true };
    case Types.UPDATE_PRODUCT_STOCK_SUCCESS:
      return { loading: false, success: true };
    case Types.UPDATE_PRODUCT_STOCK_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const RefreshStockStatusesReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.REFRESH_STOCK_STATUSES_REQUEST:
      return { loading: true };
    case Types.REFRESH_STOCK_STATUSES_SUCCESS:
      return { loading: false, success: true };
    case Types.REFRESH_STOCK_STATUSES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
